import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../Header/header";
import Menu from "../../Menu/Menu";
import PieChart from "../../PieChart/PieChart";
import "./userDetails.css";
import apiClient from "../../../api/apiClient";
import { useToast } from "../../../context/toastContext";

const UserDetails = ({ userId, userProfile, company, givenName, setCurrentCOAs, setTotalCOAs, rank }) => {
    const toast = useToast();
    const { id } = useParams();
    const [user, setUser] = useState({});
    const [coas, setCoas] = useState([]);
    const [yellow, setYellow] = useState(0); //stores yellow color count
    const [purple, setPurple] = useState(0); //stores purple color count
    const [green, setGreen] = useState(0); //stores green color count
    const [blue, setBlue] = useState(0); //stores blue color count

    useEffect(() => { 
        let yellowCount = 0;
        let purpleCount = 0;
        let greenCount = 0;
        let blueCount = 0;

        for (let i = 0; i < coas.length; i++) {
            if (coas[i].color === "yellow") {
                yellowCount++;
            } else if (coas[i].color === "purple") {
                purpleCount++;
            } else if (coas[i].color === "green") {
                greenCount++;
            } else if (coas[i].color === "blue") {
                blueCount++;
            }
        }

        setYellow(yellowCount);
        setPurple(purpleCount);
        setGreen(greenCount);
        setBlue(blueCount);
    }, [coas]);

    useEffect(() => {
        if (id) {
            apiClient
                .get(`/user/get-user-info`)
                .then((response) => response.data)
                .then((data) => {
                    if (data) {
                        setUser(data);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            const fetchCoas = async () => {
                const response = await apiClient.get(`/coas?userId=${id}`);
                setCoas(response.data);
            };

            fetchCoas(); // Fetch the COAs immediately
        }
    }, [id]);

    const sendEmail = async (event) => {
        event.preventDefault();

        const title = event.target.elements.title.value;
        const message = event.target.elements.message.value;

        try {
            const response = await apiClient.post(`/contact/email/individual`, {
                email: user.email,
                title: title,
                message: message,
            });

            if (response.data.success) {
                toast.success("Email sent successfully");
            } else {
                toast.error("Failed to send email");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred while sending the email");
        }
    };

    return (
        <div>
            <div className="dash-coa">
                {/* Display user details */}
                {user && coas && (
                    <div className="user-details-container">
                        <div className="userData">
                            <h2>Profile: {user.profile ? user.profile.toUpperCase() : "Loading..."}</h2>
                            <h2>Company: {user.company ? user.company.toUpperCase() : "Loading..."}</h2>
                            <h2>CoAs uploaded: {coas.length}</h2>
                            {user.friends && <h2>connections: {user.friends.length}</h2>}

                            <div id="myPieChart" className="userPieChart">
                                <PieChart data={[green, blue, yellow, purple]} />
                            </div>
                        </div>
                        <div className="contact-form-email">
                            <h2>
                                <strong>Send User an email</strong>
                            </h2>
                            <form className="send-email-form" onSubmit={sendEmail}>
                                <br />
                                <label>
                                    Title:
                                    <input type="text" name="title" className="title-textbox-email" />
                                </label>
                                <br />
                                <label>
                                    Message:
                                    <textarea
                                        name="message"
                                        style={{ resize: "both" }}
                                        className="message-textArea-email"
                                    />
                                </label>
                                <br />
                                <input type="submit" value="Send" />
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserDetails;
